import { toast } from 'react-toastify';
import { ApolloError } from '@apollo/client';
import type { ReactText } from 'react';

/**
 * Handles common COA error cases with consistent error messaging
 * @param error The error object from the mutation
 * @param toastId The ID of an existing toast to update
 * @param externalId The external ID value that might be causing the duplicate error
 * @returns true if the error was handled, false otherwise
 */
export const handleCoaError = (
  error: unknown,
  toastId: ReactText,
  externalId?: string | null,
): void => {
  if (
    error instanceof ApolloError &&
    error.message.includes(
      'duplicate key value violates unique constraint "coa_contract_external_id_root_org_uniq__idx"',
    )
  ) {
    toast.update(toastId, {
      render: `External ID "${externalId}" already exists`,
      type: toast.TYPE.ERROR,
      isLoading: false,
    });
    return;
  }

  // Generic error handling
  toast.update(toastId, {
    render: 'Error saving COA',
    type: toast.TYPE.ERROR,
    isLoading: false,
  });

  console.error('Error saving COA', error);
};
